import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=ae385cf4&scoped=true&"
import script from "./MyDocuments.ts?vue&type=script&lang=ts&"
export * from "./MyDocuments.ts?vue&type=script&lang=ts&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=ae385cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae385cf4",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QCard,QCardSection,QSeparator,QBtn,QMenu,QTr,QTd}, component.options.components || {})
